import { Config } from '@chegg-wt/core/config'
import { ValueProps } from '@chegg-wt/core/state/user/types'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'

export const getValueProps = (hasFreeTrial = true, price = '$9.95'): ValueProps => {
  const termStyling = `color:${FantaTheme.colors.link};text-decoration:none;`
  const termHover = `onMouseOver="this.style.textDecoration='underline'" onMouseOut="this.style.textDecoration='none'"`
  const seeTerms = `See <a href='${Config.trialTermsAndConditionsUrl}' target='__blank' style='${termStyling}' ${termHover}>terms & conditions</a>`
  const footer = hasFreeTrial
    ? `3-day free trial, cancel anytime.  ${seeTerms}`
    : `${price} / month, cancel anytime.  ${seeTerms}`
  return {
    header: `${Config.siteName} subscription includes`,
    bullet1: 'Instant plagiarism & grammar checks',
    bullet2: 'Expert proofreading for papers on any subject',
    bullet3: 'Citations in MLA, APA, Chicago & more',
    footer,
    bulletHexColor: FantaTheme.colors.cheggOrange,
    colorTheme: 'dark',
  }
}
